/**============================================================
*   [form] agreeWP
*   description : チェックボックス後ボタンの活性・非活性を変更する処理を記述（WP用）
============================================================*/
const policyCheckbox = document.getElementById('policy-1');
const submitBtnWrapper = document.getElementById('submit-wrapper');

function setSubmitButtonState(disabled) {
  const submitBtn = submitBtnWrapper.firstElementChild;
  submitBtnWrapper.classList.toggle('is-disabled', disabled);
  submitBtn.disabled = disabled;
}

if (policyCheckbox && submitBtnWrapper) {

  document.addEventListener('DOMContentLoaded', () => {
    setSubmitButtonState(!policyCheckbox.checked);
  });

  policyCheckbox.addEventListener('click', () => {
    setSubmitButtonState(!policyCheckbox.checked);
  });
}
